import { tt } from "../i18n/i18n";

type ValidationType = "id" | "url";

interface ValidationSuccess {
  isValid: true;
  appId: string;
  type: ValidationType;
}

interface ValidationError {
  isValid: false;
  error: string;
  appId: null;
}

type ValidationResult = ValidationSuccess | ValidationError;

export function validateAppStoreLink(input?: string): ValidationResult {
  if (!input) {
    return {
      isValid: false,
      error: tt("apple_store_empty_error"),
      appId: null
    };
  }

  const appIdPattern = /^\d{9,11}$/;
  const urlPatterns: RegExp[] = [
    /^https?:\/\/apps\.apple\.com\/\w{2}\/app\/.*?\/id(\d{9,11})\/?(?:\?.*)?$/, // Country-specific URL
    /^https?:\/\/apps\.apple\.com\/app\/.*?\/id(\d{9,11})\/?(?:\?.*)?$/, // Generic URL
    /^https?:\/\/itunes\.apple\.com\/\w{2}\/app\/.*?\/id(\d{9,11})\/?(?:\?.*)?$/ // Legacy iTunes URL
  ];

  if (appIdPattern.test(input)) {
    return {
      isValid: true,
      appId: input,
      type: "id"
    };
  }

  for (const pattern of urlPatterns) {
    const match = input.match(pattern);
    if (match != null && match[1]) {
      return {
        isValid: true,
        appId: match[1],
        type: "url"
      };
    }
  }

  return {
    isValid: false,
    error: tt("apple_store_invalid_format_error"),
    appId: null
  };
}
